import Vue from 'vue';
import VueRouter from 'vue-router';
import axios from 'axios';
import ElementUI from 'element-ui';
import lang from 'element-ui/lib/locale/lang/es';
import locale from 'element-ui/lib/locale';
import VeeValidate, { Validator } from 'vee-validate';
import VueValidationEs from 'vee-validate/dist/locale/es.js';
import { WindowsToaster } from 'node-notifier';
import FullCalendar from 'vue-full-calendar';


import './services/validator.js';
//css
import 'element-ui/lib/theme-chalk/index.css';
import 'fullcalendar/dist/fullcalendar.css';
import 'vue-multiselect/dist/vue-multiselect.min.css';

window.Vue = Vue;
Vue.use(VueRouter);
window.axios = axios;
Vue.use(ElementUI)
locale.use(lang);
Vue.use(FullCalendar)


Vue.use(VeeValidate, {
    // locale: 'es',
    dictionary: {
        es: VueValidationEs // si no hay valores o muestra el valore deecto invalid agregar aqui
    },
    classes: true,
    classNames: {
        valid: 'is-valid',
        invalid: 'is-invalid'
    },
    aria: true,
    errorBagName: 'errors', // change if property conflicts
    events: 'input|blur',
    fieldsBagName: 'fields',
    i18n: null, // the vue-i18n plugin instance
    i18nRootKey: 'validations', // the nested key under which the validation messages will be located
    inject: true,
    locale: 'es',
    validity: false,
    useConstraintAttrs: true
});



window.axios.defaults.baseURL = process.env.PATH_SERVE;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
//window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('auth_token');

//window.axios.defaults.headers.common['Connection'] = 'keep-alive';
window.axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
//window.axios.defaults.headers.common['Access-Control-Allow-Methods'] = 'POST';
//window.axios.defaults.headers.common['Access-Control-Allow-Credentials'] = 'false';
window.axios.defaults.headers.common['Content-Type'] = 'application/json';
window.axios.defaults.headers.common['Accept'] = 'application/json';
//window.axios.defaults.headers.common['Content-Length'] = '1';


/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

/* let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
} */

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: 'your-pusher-key'
// });


// WEBPACK FOOTER //
// ./src/bootstrap.js